module.exports = __webpack_public_path__ + "img/7.deb2a7a2.png";